<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------

========================================================================================== -->


<script src="../../store/email/moduleEmail.js"></script>
<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">ログイン</h4>
                  <p>お問い合わせ管理システム</p>
                </div>

                <form @submit.prevent="checkLogin()">
                  <vs-input
                    name="ログインID"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label="ログインID"
                    :placeholder="autofill ?'':''"
                    v-model="login_id"
                    v-validate="'required|max:15|login_id'"
                    class="w-full"
                  />
                  <span style="color: red">{{ errors.first("ログインID") | convertError }}</span>

                  <vs-input
                    type="password"
                    name="パスワード"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label="パスワード"
                    :placeholder="autofill ? '':''"
                    v-model="password"
                    v-validate="'required|min:6'"
                    class="w-full mt-6"
                  />
                  <span style="color: red">{{ errors.first("パスワード") | convertError }}</span>

                  <vs-row class="flex flex-wrap mt-5" >
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-4 mr-2">ログイン状態を保存する</vs-checkbox>
                  </vs-row>
                  <vs-row vs-type="flex" vs-justify="flex-start" class="mb-5 ml-2" >
                      <router-link to="forgot-password">パスワードをお忘れですか?</router-link>
                  </vs-row>
                  <vs-divider>
                    <vs-input type="submit" value="ログイン" class="login-button"/>
                  </vs-divider>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      login_id: "",
      password: "",
      autofill: false,
      checkbox_remember_me: false,
    };
  },
  watch:{
    'login_id'(){
      this.autofill = true;
    }
  },

  methods: {
    ...mapActions({
      handleLogin: "loginModule/handleLogin",
      handleDeskTokenLogin : "loginModule/handleDeskTokenLogin",
    }),

    //handle Login
    checkLogin() {
      let root = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          let account = {
            login_id: this.login_id,
            password: this.password,
            remember_me: this.checkbox_remember_me,
            redirect: this.$route.query.redirect,
          };
          this.handleLogin({account, 'acl':root.$acl});
        }
      });
    },
  },
  mounted(){
    if (this.$route.query.t) {
      let root = this;
      let account = {
          token: atob(this.$route.query.t),
          redirect: this.$route.query.redirect
      };
      this.handleDeskTokenLogin({account, 'acl':root.$acl});
    }
  }
};
</script>

<style lang="scss">
  .login-button .vs-con-input input{
    cursor: pointer !important
  }
</style>
